import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=77afd1fe&scoped=true&"
var script = {}
import style0 from "./Home.vue?vue&type=style&index=0&id=77afd1fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77afd1fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/pico/Documents/nesztler.com/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
installComponents(component, {VContainer})
